import { BoxProps, CSSObject } from '@chakra-ui/react';

export const wrapperProps: BoxProps = {
  h: '100%',
  minW: ['unset', null, '460px'],
  maxW: ['100vw', null, null],
  display: 'flex',
  justifyContent: 'center',
  fontFamily: 'body',
  sx: {
    'div:first-child': {
      display: 'flex',
      flexDir: 'column',
      fontSize: 'xs',
      fontWeight: 'bold',
      alignItems: 'flex-start',
      svg: {
        boxSize: '2.5',
        mr: '1',
        mb: '1',
      },
    },
  },
  bg: 'alpha.600',
  borderTop: ['2px', '2px', '0px'],
  borderColor: 'beta.300',
};

export const TextForgotPasswordSuccess: CSSObject = {
  color: 'gamma.200',
  fontSize: 'sm',
  fontStyle: 'normal',
  fontWeight: 'medium',
  mb: '2',
  '+ a': {
    display: 'none',
  },
};

export const linkLoginProps: CSSObject = {
  color: 'gamma.600',
  fontWeight: 'bold',
  fontSize: 10,
  textTransform: 'unset',
  mb: '4',
};

export const ForgotPasswordButton: CSSObject = {
  fontSize: 'sm',
  fontWeight: 'normal',
  textTransform: 'uppercase',
};
